export default "__VITE_ASSET__CR4MNr49__"